// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"227":"047fd7c480cf7e1d","346":"9f89454b626514e0","401":"8b12ed64d5b23bea","505":"7905a1d8c7a4c10c","700":"3660af3fbeb58eaf","770":"ce04eaf84c3de60f","815":"381742780379cbf2"}[chunkId] + ".js";
};